import React, {Component} from 'react';

import {assetError, assetProgress} from 'actions/asset-actions';
import store from 'store';
import GalleryItem from 'components/views/gallery-item'
import FileUpload from 'utils/file-upload';
import _ from 'lodash';

class GalleryItemContainer extends Component {


    componentWillUnmount() {
        if (this.uploadWorker) {
            this.uploadWorker.removeEventListener('message', this.uploadWorkerMessageBound);
        }
    }

    componentDidMount() {
        store.dispatch(assetProgress(this.props.tempUUID, 'INIT'));
        if (this.props.errors &&  this.props.errors.length) {
            console.log("Mounted with errors!!")
        }

        if (this.props.uploadStatus === 'PROCESSING') {
            const params = Object.assign({}, this.props, {ownerUserDbId: this.props.userId});
            const user = _.pick(store.getState().userProfile, ['username', 'firstName', 'lastName']);
            const fileUpload = new FileUpload(params, user);
            fileUpload.listenOnAsset(this.props.assetUUID, user)
        }

    }

    markError(assetId, errorCode, errorMessage) {
        store.dispatch(assetError(assetId, errorCode, errorMessage));
    }

    render() {
        return <GalleryItem {...this.props} onError={this.markError.bind(this, this.props.assetUUID, 'load')}/>;
    }
}

export default GalleryItemContainer;
